import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { fetchDemandsTableData } from '../../../Service/APIService';
import Auth from '../../../shared/Auth';
import { constants } from '../../../shared/constants';
import EmptyWidget from '../../Custom/EmptyWidget';
import ChartLoader from '../../Loaders/ChartLoader';
import '../../../contents/css/table.css';
import TableHeader from '../../Custom/TableHeader';

const PeakDemandTable = ({ type, id, units }) => {
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(true);

  const fetchData = async (_type, _id) => {
    setLoading(true);
    const checkToken = await Auth();
    if (checkToken) {
      fetchDemandsTableData(_type, _id)
        .then((res) =>
          setData(res.data.statusCode === 200 ? res.data.result : [])
        )
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    fetchData(type, id);
  }, [type, id]);

  const createTbale = () =>
    data.map((item, i) =>
      item.timeInterval !== 'month' && item.timeInterval !== 'year' ? (
        <tr key={i}>
          <td>{i === 0 ? 'Today' : ''}</td>
          <td>{_.startCase(item.timeInterval)}</td>
          <td>{item.date !== null ? item.time : ''}</td>
          <td>{item.peakDemand.toFixed(2)}</td>
        </tr>
      ) : (
        <tr key={i}>
          <td>{_.startCase(item.timeInterval)}</td>
          <td>{item.date !== null ? item.date.split(' ')[0] : ''}</td>
          <td>{item.time}</td>
          <td>{item.peakDemand.toFixed(2)}</td>
        </tr>
      )
    );

  if (isLoading) {
    return <ChartLoader height="150" width="600" />;
  }
  return (
    <TableHeader title={'Peak Demand Table'}>
      {data.length > 0 ? (
        <table className="tbl">
          <thead>
            <th>Time Interval</th>
            <th>Reading from</th>
            <th>Time of Reading</th>
            <th>Demand ({units?.powerUnit || ''})</th>
          </thead>
          <tbody>{createTbale()}</tbody>
        </table>
      ) : (
        <EmptyWidget emptyText={constants.core.EMPTY_CHART_MSG} />
      )}
    </TableHeader>
  );
};

export default PeakDemandTable;
